import styled from '@emotion/styled'
export const styleWrapper = `
  padding-top:20px;
  padding-bottom:20px;
  overflow-y:auto;
  height:100%;
  scrollbar-width: none;
  position:relative;
  ::-webkit-scrollbar {
    display: none;
  }
`
export const StyleInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  border-radius: 8px;
  width: 100%;
  background: ${(props: any) => props.theme.colors.white};
`

export const StyleInfoRowWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
`

export const StyleTag = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.white100};
  padding: 5px 7px;
  border-radius: 4px;
  display: flex;
  column-gap: 5px;
  font-size: 12px;
  align-items: center;
  color: ${(props: any) => props.theme.colors.text};
`
